export default __webpack_public_path__ + "static/media/chatbot_adoption.bfc2aa3f.webp";